var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-expansion-panel",
    {
      nativeOn: {
        mouseover: function($event) {
          _vm.hover = true
        },
        mouseleave: function($event) {
          _vm.hover = false
        }
      }
    },
    [
      _c("v-expansion-panel-header", { attrs: { "hide-actions": "" } }, [
        _vm._v("\n    " + _vm._s(_vm.cassetteTitle) + "\n    "),
        _c(
          "div",
          {
            staticClass: "cassette-header-buttons-container",
            class: { hover: _vm.hover }
          },
          [
            _c(
              "v-btn",
              {
                staticClass: "cassette-button",
                attrs: { icon: "", height: "24px", width: "24px" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.$emit("open-cassette-form", _vm.cassette)
                  }
                }
              },
              [
                _c("v-icon", { attrs: { size: "20", color: "accent" } }, [
                  _vm._v("edit")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                staticClass: "cassette-button",
                attrs: { icon: "", height: "24px", width: "24px" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.$emit("open-delete-cassette-dialog", {
                      uuid: _vm.cassette.ct_uuid,
                      label: _vm.cassette.ct_label
                        ? _vm.cassette.ct_label
                        : "" + _vm.cassette.ct_id
                    })
                  }
                }
              },
              [
                _c("v-icon", { attrs: { size: "20", color: "accent" } }, [
                  _vm._v("delete")
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "v-expansion-panel-content",
        _vm._l(_vm.connections, function(connection, positionInCassette) {
          return _c("connection", {
            key: positionInCassette,
            staticClass: "connection",
            attrs: {
              connection: _vm.cassetteIsVirtualCassette
                ? connection
                : _vm.getConnectionByIndex(positionInCassette + 1)
            },
            on: {
              "open-menu": _vm.openMenu,
              "open-tube-form": function($event) {
                return _vm.openTubeForm($event, positionInCassette + 1)
              }
            }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75b3da46", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75b3da46","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/InsidePlan/Cassette.vue
// module id = null
// module chunks = 